<template>
  <div class="members">
    <router-view />
    <div class="content--main">
      <div class="row" v-if="user">
        <div class="col-12 member--profile-wrapper">
          <div class="member--profile">
            <WidgetDetails title="Profile">
              <div class="d-flex">
                <div class="widget--avatar">
                  <img
                    v-if="user.avatar"
                    :src="user.avatar"
                    alt="User Avatar"
                  />
                  <span v-else>{{ user.firstName[0] }}</span>
                </div>
                <div class="widget--details-wrapper">
                  <h4>{{ user.firstName }} {{ user.lastName }}</h4>
                  <p class="-muted">
                    <img
                      src="~@/assets/media/icons/user.svg"
                      alt="member icon"
                    />
                    <span v-if="user.Roles && user.Roles.length > 0">{{
                      user.Roles[0].name
                    }}</span>
                  </p>
                  <div class="row">
                    <div class="col">
                      <p v-if="user.email">
                        <img
                          src="~@/assets/media/icons/email.svg"
                          alt="email icon"
                        />{{ user.email }}
                      </p>
                      <p v-if="user.mobile">
                        <img
                          src="~@/assets/media/icons/call.svg"
                          alt="phone icon"
                        />{{ user.mobile }}
                      </p>
                    </div>
                    <div class="col">
                      <template
                        v-if="user.Companies && user.Companies.length > 0"
                      >
                        <p>
                          <img
                            v-if="user.Companies[0].name"
                            src="~@/assets/media/icons/company.svg"
                            alt="email icon"
                          />{{ user.Companies[0].name }}
                        </p>
                        <p>
                          <img
                            v-if="user.Companies[0].mobile"
                            src="~@/assets/media/icons/assignment.svg"
                            alt="phone icon"
                          />{{ user.Companies[0].mobile }}
                        </p>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="row align-items-end justify-content-between widget--table-row mx-0"
              >
                <div class="col px-0"><h4>Invoice</h4></div>
                <div class="col px-0 text-right">
                  <ActionButton
                    label="Make a Booking"
                    class="mt-0 d-inline-block w-auto"
                    :theme="{ primary, secondary, event, danger }"
                    @customEvent="
                      $router.push({
                        name: `${$route.matched[0].name}-booking`,
                        params: { id: user.id }
                      })
                    "
                  />
                </div>
              </div>
              <div class="row mx-0">
                <div class="col" v-if="invoices.length > 0">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Invoice ID</th>
                        <th>Amount</th>
                        <th>Payment Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <template>
                        <tr v-for="order of invoices" :key="order.id">
                          <td>{{ order.code }}</td>
                          <td>
                            <template
                              v-if="
                                order.code != 'Contract for Private Office' ||
                                  order.code != 'Contract for Virtual Office'
                              "
                            >
                              <span v-if="order.totalAmount">
                                Php
                                {{
                                  order.totalAmount.toLocaleString("en-US", {
                                    minimumFractionDigits: 2
                                  })
                                }}
                              </span>
                            </template>
                          </td>
                          <td class="font-weight-bold">
                            <span class="text-warning" v-if="order.cancelledAt">
                              Cancelled
                            </span>
                            <span class="text-success" v-else-if="order.paidAt">
                              &#10003; Paid
                            </span>
                            <span class="text-danger" v-else>
                              Unpaid
                            </span>
                          </td>
                          <td>
                            <span
                              v-if="
                                order.code === 'Contract for Private Office' ||
                                  order.code === 'Contract for Virtual Office'
                              "
                              >&mdash;</span
                            >
                            <router-link
                              v-else
                              :style="{ color: primary }"
                              tag="a"
                              :to="
                                '/' +
                                  mainModule +
                                  '/booking/' +
                                  user.id +
                                  '/invoice/' +
                                  order.id
                              "
                              >View</router-link
                            >
                            <a
                              v-if="!order.paidAt && !order.cancelledAt"
                              @click="handleCancelInvoice(order.id, order.code)"
                              :style="{ color: danger }"
                              class="ml-10 tag-link"
                              >Cancel</a
                            >
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
                <div class="col mt-3 length-0" v-else>
                  <span colspan="4">No orders found</span>
                </div>
              </div>
            </WidgetDetails>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ActionButton from "@/components/ActionButton";
import WidgetDetails from "@/modules/concierge/elements/WidgetDetails";
import axios from "@/helpers/axios";
import { dateToday } from "@/helpers/date";

export default {
  name: "ConciergeSingleMember",
  components: {
    WidgetDetails,
    ActionButton
  },
  data() {
    return {
      user: {},
      invoices: [],

      mainModule: this.$route.matched[0].name,
      searchWord: "",
      activeIndex: this.$route.params.id,
      selectedUserInvoices: null,
      widgetOptions: [
        {
          icon: "edit",
          label: "Edit Details",
          method: "editMemberDetails"
        },
        {
          icon: "edit",
          label: "Change Password",
          method: "changePassword"
        },
        {
          icon: "Deactivate",
          label: "Deactivate",
          method: "deleteMember"
        }
      ]
    };
  },
  computed: {
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    }
  },
  created() {
    this.getUser();
  },
  methods: {
    ...mapActions({
      changeActiveTrail: "changeActiveTrail"
    }),
    async getUser() {
      const { matched, path, params } = this.$route;
      await axios
        .get(`/users?id=${params.id}`)
        .then(response => {
          const users = response.data.data;
          if (users && users.length > 0) {
            this.user = users[0];
            this.changeActiveTrail([
              { name: "Home", link: matched[0].path },
              { name: "Members", link: path },
              { name: `${this.user.firstName} ${this.user.lastName}` }
            ]);
            this.handleGetBookings();
          } else {
            this.$toastr.error("User cannot be found", "Oops!");
          }
        })
        .catch(error => {
          this.$toastr.error(error, "Oops!");
        });
    },
    handleCancelInvoice(id, code) {
      this.$swal({
        title: "Are you sure you want to cancel this order?",
        text: code,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        confirmButtonColor: "#e15a4e",
        cancelButtonText: "No",
        reverseButtons: true
      }).then(result => {
        if (result.value) {
          axios
            .patch("/orders/" + id, {
              cancelledAt: dateToday()
            })
            .then(() => {
              this.handleGetBookings();
            });
        }
      });
    },
    async handleGetBookings() {
      if (this.user.id) {
        this.invoices = null;
        let orders = await axios
          .get(`/users/${this.user.id}/orders`)
          .then(response => response.data.data.rows);
        this.invoices = orders || null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.members {
  padding: 0 15px;
  .content--main {
    height: calc(
      100vh - 274px
    ); /* height of viewport minus the sum of nav.header and <SearchBar/> */
    overflow-x: hidden;
    overflow-y: auto;
    padding-bottom: 20px;
    padding-top: 20px;
    & > .row {
      height: 100%;
      div[class^="col-"] {
        height: 100%;
        overflow: auto;
      }
    }
    .member {
      &--profile {
        background-color: $gray-50;
        border-radius: 5px;
        max-height: 100%;
        overflow: auto;
        .widget--avatar {
          margin-right: 30px;
          span {
            align-items: center;
            background-color: $brand-primary;
            border-radius: 50%;
            color: $white;
            display: flex;
            font-family: "Gotham";
            font-size: $font-size-xl;
            font-weight: 500;
            height: 110px;
            justify-content: center;
            width: 110px;
          }
          img {
            border-radius: 50%;
            display: block;
            height: 110px;
            object-fit: cover;
            width: 110px;
          }
        }
        .widget--details-wrapper {
          h4 {
            color: $gray-900;
            font-size: $font-size-md;
            font-weight: 500;
            margin-bottom: 10px;
          }
          p {
            align-items: flex-start;
            display: flex;
            font-family: "Gotham Book";
            font-size: $font-size-sm;
            img {
              margin-right: 10px;
              height: 20px;
              width: 20px;
            }
            &.-muted {
              color: $gray-550;
            }
          }
        }
        .widget--table-row {
          border-bottom: 1px solid $gray-250;
          padding: 10px 0;
          h4 {
            color: $gray-900;
            font-size: $font-size-xs;
            font-weight: 500;
          }
        }
        .length-0 {
          span {
            color: $gray-900;
            font-family: "Gotham Book";
            font-size: $font-size-sm;
            text-align: left;
          }
        }
        .table {
          font-size: $font-size-xs;
          thead {
            th {
              color: $gray-900;
              font-weight: 500;
            }
          }
          tbody {
            td {
              color: $gray-900;
              font-family: "Gotham Book";
            }
          }
        }
      }
    }
    .length-0 {
      span {
        color: $gray-900;
        font-family: "Gotham Book";
        font-size: $font-size-sm;
        text-align: left;
      }
    }
  }
}
.tag-link {
  cursor: pointer;
  &:hover {
    text-decoration: underline !important;
  }
}
</style>
